import FuseSvgIcon from '@fuse/core/FuseSvgIcon/FuseSvgIcon';
import { Button, Icon, IconButton, Tooltip, Typography } from '@mui/material';
import jwtDecode from 'jwt-decode';
import React, { Component, useContext, useEffect, useState } from 'react';
import OAuthService from 'src/app/auth/services/oAuthService';
import oAuthServiceConfig from 'src/app/auth/services/oAuthService/oAuthServiceConfig';
import AddOKRPopup from './AddOKRPopup';
import { getGroupingRowData, handleSuccessMsg, showEmpChart } from './OkrPerformance';
import ShowComments from './ShowComments';
import AddComments from './AddComments';
import moment from 'moment';
import { createContext } from 'react';

const HideShowCommentPopup = createContext();
const HideShowAddCommentPopup = createContext();

const GroupRowInnerRenderer = (props) => {
  const node = props.node;
  const [fieldName, setfieldName] = useState(node.field);
  const [fieldValue, setfieldValue] = useState(node.key);
  const [finalWeightedPercentage, setFinalWeightedPercentage] = useState();
  const [emplist, setEmplist] = useState([]);
  const [open, setOpen] = useState(false);
  const [chartOpen, setChartOpen] = useContext(showEmpChart);
  const [showCommentOpen, setShowCommentOpen] = useState(false);
  const [addCommentOpen, setAddCommentOpen] = useState(false);
  const [groupData, setGroupData] = useContext(getGroupingRowData)
  const [successMsg, setSuccessMsg] = useContext(handleSuccessMsg)
  const okrurl = `${process.env.REACT_APP_HR_API_KEY_URL}${oAuthServiceConfig.performance}`;

  useEffect(() => {
    let finalWeightedPercentage = 0;
    node.allLeafChildren.map((children) => {
      if (children.data) {
        if (children.data.finalWeightedPercentage) {
          finalWeightedPercentage = Number(finalWeightedPercentage) + Number(children.data.finalWeightedPercentage);
        }
      }
    })
    setFinalWeightedPercentage(finalWeightedPercentage)
    if (node.field === 'employeeEmail') {
      employees()
    }
  }, [])

  const dataChangedListener = () => refreshUi();

  const employees = async () => {
    const empUrl = `${process.env.REACT_APP_HR_API_KEY_URL}${oAuthServiceConfig.employees}`;
    try {
      const employees = [];
      const emplist = await OAuthService.getList(empUrl);
      emplist?.data?._embedded?.employees.map((emp, index) => {
        employees.push({ name: emp.displayName, id: emp.email, department: emp.department })

      });
      setEmplist(employees)
    } catch (error) {

    }
  }

  const refreshUi = () => {
    const node = props.node;
    let finalWeightedPercentage = 0;
    node.allLeafChildren.map((children) => {
      if (children.data) {
        let calculateFinal = Number(children.data.finalWeightedPercentage || 0);
        if (children.data.weightagePercentage && children.data.grading) {
          calculateFinal = Number(Number((children.data.weightagePercentage * children.data.grading) / 100)).toFixed(2);
        } else {
          finalWeightedPercentage = Number(finalWeightedPercentage) + Number(children.data.finalWeightedPercentage || 0);
        }
        finalWeightedPercentage = Number(Number(finalWeightedPercentage) + Number(calculateFinal)).toFixed(2);
      }
    })
    setfieldValue(node.key);
    setfieldName(node.field);
    setFinalWeightedPercentage(finalWeightedPercentage);
  }
  useEffect(() => {
    props.api.addEventListener('cellValueChanged', dataChangedListener);
    props.api.addEventListener('filterChanged', dataChangedListener);

    return () => {
      props.api.removeEventListener('cellValueChanged', dataChangedListener);
      props.api.removeEventListener('filterChanged', dataChangedListener);
    };
  }, []);
  let empName = '';
  if (fieldName === 'employeeEmail') {

    const empname = emplist?.filter((emp) => {
      if (emp.id === fieldValue) {
        return emp
      }
    });
    empName = empname.length > 0 && empname[0].name
  }

  const token = (localStorage && localStorage.getItem('token')) && jwtDecode(localStorage.getItem('token'));
  const roleMD = token?.scope && token?.scope.includes('ROLE_MD') || token?.scope?.includes('ROLE_HR');
  const diff = new Date(node?.allLeafChildren[0].data?.dueDate) - new Date();
  const diffDays = Math.ceil(diff / (1000 * 60 * 60 * 24));
  const now = new Date();
  now.setHours(10, 0, 0, 0);
  const futureDate = new Date().getTime();
  const timeleft = new Date(node?.allLeafChildren[0].data?.dueDate) === new Date() ? futureDate - now.getTime() : 1;

  function diff_weeks(dt2, dt1) {
    var diff = (dt2.getTime() - dt1.getTime()) / 1000;
    diff /= (60 * 60 * 24 * 7);
    return Math.abs(Math.round(diff));

  }

  const addWeeksToDate = (dateObj, numberOfWeeks) => {
    dateObj.setDate(dateObj.getDate() + numberOfWeeks * 7);
    return dateObj;
  }

  const handleSendMail = async (props) => {
    try {
      const data = {
        "okrId": props.okrId,
        "duration": props.duration,
        "durationType": props.durationType,
        "dueDate": props.dueDate
      }
      const sendMail = await OAuthService.addData(okrurl + '/sendNotification', data)
      if (sendMail?.data) {
        setSuccessMsg("Mail sent successfully.")
      }
    } catch (error) {

    }
  }

  const getTotalWeeks = diff_weeks(new Date(node?.allLeafChildren[0].data?.startDate), new Date(node?.allLeafChildren[0].data?.endDate));
  const duration = node?.allLeafChildren[0].data?.weekDuration || 3;

  let weekstartDate = moment(new Date(node?.allLeafChildren[0].data?.startDate)).format('YYYY-MM-DD')
  let weekendDate = moment(addWeeksToDate(new Date(node?.allLeafChildren[0].data?.startDate), duration)).format('YYYY-MM-DD')
  const chunks = []
  for (let i = 0; i <= getTotalWeeks; i += duration) {
    const startWeek = moment(weekstartDate).week();
    const endWeek = moment(weekendDate).week()
    const week = (startWeek + '-' + endWeek).toString();
    chunks.push({ startDate: weekstartDate, endDate: weekendDate, weeks: week })
    weekstartDate = moment(weekendDate).add(1, 'days').format('YYYY-MM-DD');
    weekendDate = moment(addWeeksToDate(new Date(weekstartDate), duration)).format('YYYY-MM-DD')
    if (addWeeksToDate(new Date(weekstartDate), duration) > new Date(node?.allLeafChildren[0].data?.endDate)) {
      weekendDate = moment(new Date(node?.allLeafChildren[0].data?.endDate)).format('YYYY-MM-DD')
    }
  }
  let updatenumber = 0;
  node?.allLeafChildren && node?.allLeafChildren.map((child) => {
    if (child.data?.updateNo) {
      updatenumber = child.data?.updateNo > updatenumber ? child.data?.updateNo : updatenumber;
    }
  })
  const total = Number(Number(Number(updatenumber) * 100) / getTotalWeeks).toFixed(2);

  const diffFromEndDate = new Date(moment(new Date(node?.allLeafChildren[0].data?.dueDate)).format('YYYY-MM-DD')) - new Date();
  let diffFromEndDateDays = Math.ceil(diffFromEndDate / (1000 * 60 * 60 * 24));

  let isCommentedValue = null;
  if(fieldName === 'isCommentAdded'){
    if(fieldValue === 'true' && node?.allLeafChildren[0].data?.objectiveValue){
      isCommentedValue = 'Submitted';
    }else if(fieldValue === 'false' && node?.allLeafChildren[0].data?.objectiveValue){
      isCommentedValue = 'Not Submitted';
    }else{
      isCommentedValue = null;
    }
  }

  return (
    <div className='flex w-full items-center'>
      {fieldName === 'quarterly' ?
        <>
          <span className="groupTitle font-bold">
            {fieldValue}
          </span>
          <div className='ml-[10px] flex  items-center'>
            {(node?.allLeafChildren && node?.allLeafChildren[0].data.grading > 0) && <IconButton
              size="small"><FuseSvgIcon size={18} color="success">material-outline:verified</FuseSvgIcon></IconButton>}

            {node?.allLeafChildren[0].data?.isCommentAdded === 'false' ? <span className='inline-block pr-5'><Typography>Update not added</Typography></span> :
              node?.allLeafChildren[0].data?.isCommentAdded === 'true' ? <span className='inline-block pr-5'><Typography>Update added</Typography></span> :
                <span className='inline-block pr-5'><Typography>No Updates Available</Typography></span>}

            {!node?.allLeafChildren[0].data?.isCommentAdded && <span className='inline-block	'><Typography
              className={diffFromEndDateDays <= 3 ? 'text-red-500' : diffFromEndDateDays <= 7 ? 'text-orange-500' : diffFromEndDateDays <= 14 ?
                'text-yellow-500' : 'text-green-500'} >Due Date: {node?.allLeafChildren[0].data?.dueDate}</Typography></span>}

            {(node?.allLeafChildren[0].data?.dueDate && !node?.allLeafChildren[0].data?.isCommentAdded && diffDays <= 3 && (token.scope.includes('ROLE_MD') || token.scope.includes('ROLE_ADMIN') || token.scope.includes('ROLE_HR'))) && <Tooltip title={'Send Email'}>
              <IconButton
                size="small"
                onClick={(e) => handleSendMail({
                  okrId: node?.allLeafChildren[0].data?.okrid,
                  duration: timeleft === 0 ? timeleft : diffDays,
                  durationType: timeleft === 0 ? 'hour' : 'days',
                  dueDate: node?.allLeafChildren[0].data?.dueDate
                })}
              >
                <FuseSvgIcon size={18} color={timeleft === 0 ? 'error' : diffDays === 3 ? 'info' : diffDays === 2 ? 'warning' : diffDays === 1 ? 'error' : 'error'}>heroicons-outline:mail</FuseSvgIcon>
              </IconButton>
            </Tooltip>}
            {((node?.allLeafChildren && !node?.allLeafChildren[0].data?.grading)) && <Tooltip title={'Add Objective'}>
              <IconButton
                size="small"
                onClick={() => setGroupData({ event: props, type: 'addCategory' })}
              >
                <FuseSvgIcon size={18}>heroicons-outline:plus-circle</FuseSvgIcon>
              </IconButton>
            </Tooltip>}
            {node?.allLeafChildren[0].data?.objectiveValue && <Tooltip title={"View Updates"}>
              <IconButton className="p-5" onClick={() => setShowCommentOpen(true)}>
                <FuseSvgIcon size={18} color="action">
                  material-outline:comment
                </FuseSvgIcon>
              </IconButton>
            </Tooltip>}
            {((!token.scope.includes('ROLE_MD') && !token.scope.includes('ROLE_ADMIN') && !token.scope.includes('ROLE_HR')) && (node?.allLeafChildren && !node?.allLeafChildren[0].data?.grading) && node?.allLeafChildren[0].data?.objectiveValue) && <Tooltip title={"Add Update"}>
              <IconButton className="p-5" onClick={() => setAddCommentOpen(true)}>
                <FuseSvgIcon size={18} color="action">
                  material-outline:add_comment
                </FuseSvgIcon>
              </IconButton>
            </Tooltip>}
            {(token.scope.includes('ROLE_MD') || token.scope.includes('ROLE_ADMIN') || token.scope.includes('ROLE_HR')) && <Tooltip title={'Delete OKR'}>
              <IconButton
                size="small"
                onClick={() => setGroupData({ event: props, type: 'deleteOkr' })}
              >
                <FuseSvgIcon size={18}>heroicons-outline:trash</FuseSvgIcon>
              </IconButton>
            </Tooltip>}
          </div>
          <div className='flex flex-row justify-end w-full ml-[200px] font-bold'>
            {total ? total : 0} %
          </div>
          {(token.scope.includes('ROLE_MD') || token.scope.includes('ROLE_ADMIN') || token.scope.includes('ROLE_HR')) && <div className='flex flex-row justify-end w-full ml-[200px] font-bold'>
            {total === 100 ? 'Ready for Grading' : 'Not ready for Grading'}
          </div>}

        </> :
        fieldName === 'employeeEmail' ?
          <>
            <span className="groupTitle font-bold">{empName}</span>
            <div className='ml-[10px]'>
              <Tooltip title={'Add OKR'}>
                <IconButton
                  size="small"
                  onClick={() => setOpen(true)}
                >
                  <FuseSvgIcon size={18}>heroicons-outline:plus-circle</FuseSvgIcon>
                </IconButton>
              </Tooltip>
              <Tooltip title={'Add OKR'}>
                <IconButton
                  size="small"
                  onClick={() => setChartOpen(true)}
                >
                  <FuseSvgIcon size={18}>material-outline:bar_chart</FuseSvgIcon>
                </IconButton>
              </Tooltip>

            </div>
            <AddOKRPopup open={open} selectedEmail={props.value} />

          </> : fieldName === "isCommentAdded" ? <span className="groupTitle font-bold">{isCommentedValue}</span> :
            <span className="groupTitle font-bold">{fieldValue}</span>}

      <HideShowAddCommentPopup.Provider value={[addCommentOpen, setAddCommentOpen]}>
        {addCommentOpen && <AddComments open={addCommentOpen} id={node?.allLeafChildren[0].data?.okrid} />}
      </HideShowAddCommentPopup.Provider>

      <HideShowCommentPopup.Provider value={[showCommentOpen, setShowCommentOpen]}>
        {showCommentOpen && <ShowComments open={showCommentOpen} id={node?.allLeafChildren[0].data?.okrid} />}
      </HideShowCommentPopup.Provider>
    </div>

  );



}

export default GroupRowInnerRenderer;
export { HideShowCommentPopup, HideShowAddCommentPopup };